import { BiPlayCircle } from 'react-icons/bi';
import { Link } from 'react-router';

import { Button } from '@/components/Button';
import { GoalIcon } from '@/components/icons/GoalIcon';
import { DonorScenario } from '@/types/scenarios';

export const Scenarios = ({ scenarios }: { scenarios: DonorScenario[] }) => {
  return (
    <section data-testid="scenarios" className="py-10 md:py-16 px-6 max-w-4xl mx-auto flex flex-col gap-4">
      <h2 className="text-xl md:text-2xl font-semibold">Choose Your Scenario</h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {scenarios.map(demo => (
          <div
            className="flex-1 shadow rounded-lg border border-cardBorderColor p-6 flex flex-col justify-between gap-2 hover:shadow-lg hover:border-buttonOrange/50 transition-all duration-300"
            key={demo.id}
          >
            <h2 className="text-xl md:text-2xl font-semibold">{demo.title}</h2>
            <p className="text-sm text-brandNeutralBlack/70 mb-2">{demo.description}</p>

            <div className="flex flex-col gap-1">
              <div className="text-sm rounded-xl p-3 bg-[#C7C7C7]/20 mb-2">
                <strong className="flex items-center gap-2">
                  <GoalIcon size={18} fill="#FE6840" /> Goal
                </strong>
                {demo.goal}
              </div>
              <p className="text-sm">
                <strong>Simulation duration:</strong> {Math.round(demo.duration / 60)} minutes
              </p>
              <p className="text-sm">
                <strong>Level:</strong> Easy
              </p>

              <Button
                component={Link}
                label="Start Simulation"
                icon={<BiPlayCircle className="w-5 h-5" />}
                to={`/demo?scenarioId=${demo.id}`}
                className="mt-2"
              />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
